// Rollback marker 2026-06-17: WSG/ÅF prices are kept ex VAT by product tax status, not frontend price rewriting.
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const menu = document.querySelector('[data-smartdna-menu]');
  const overlay = document.querySelector('[data-smartdna-menu-overlay]');
  const toggles = document.querySelectorAll('[data-smartdna-menu-toggle]');
  const closeTargets = document.querySelectorAll('[data-smartdna-menu-close]');
  const isMenuOpen = () => body.classList.contains('smartdna-reset-menu-open');
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');
  let menuReturnFocusTarget = null;

  const getMenuFocusableElements = () =>
    menu ? Array.from(menu.querySelectorAll(focusableSelector)).filter((element) => element.offsetParent !== null) : [];

  const setMenuToggleState = (open) => {
    toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Stäng meny' : 'Öppna meny');
    });
  };

  const openMenu = () => {
    if (!menu) return;
    menuReturnFocusTarget = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    body.classList.add('smartdna-reset-menu-open');
    menu.setAttribute('aria-hidden', 'false');
    menu.removeAttribute('inert');
    setMenuToggleState(true);

    window.requestAnimationFrame(() => {
      const firstFocusable = getMenuFocusableElements()[0];
      if (firstFocusable) firstFocusable.focus();
    });
  };

  const closeMenu = ({ returnFocus = true } = {}) => {
    if (!menu) return;
    body.classList.remove('smartdna-reset-menu-open');
    menu.setAttribute('aria-hidden', 'true');
    menu.setAttribute('inert', '');
    setMenuToggleState(false);

    if (returnFocus && menuReturnFocusTarget && document.contains(menuReturnFocusTarget)) {
      menuReturnFocusTarget.focus();
    }
  };

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      if (isMenuOpen()) closeMenu();
      else openMenu();
    });
  });

  closeTargets.forEach((target) => {
    target.addEventListener('click', () => {
      closeMenu({ returnFocus: !target.matches('a[href]') });
    });
  });
  if (overlay) overlay.addEventListener('click', () => closeMenu());

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isMenuOpen()) {
      closeMenu();
      return;
    }

    if (event.key !== 'Tab' || !isMenuOpen()) return;

    const focusableElements = getMenuFocusableElements();
    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstFocusable) {
      event.preventDefault();
      lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  });

  const carousels = document.querySelectorAll('[data-smartdna-hero-carousel]');
  carousels.forEach((carousel) => {
    const cards = Array.from(carousel.querySelectorAll('[data-smartdna-hero-card]'));
    if (!cards.length) return;

    let currentIndex = 0;

    const updateCards = () => {
      cards.forEach((card, index) => {
        card.classList.remove('is-active', 'is-next', 'is-tail', 'is-hidden');
        const diff = (index - currentIndex + cards.length) % cards.length;

        if (diff === 0) card.classList.add('is-active');
        else if (diff === 1) card.classList.add('is-next');
        else if (diff === 2) card.classList.add('is-tail');
        else card.classList.add('is-hidden');

        card.setAttribute('aria-hidden', diff === 0 ? 'false' : 'true');
      });
    };

    carousel.querySelectorAll('[data-smartdna-hero-next]').forEach((button) => {
      button.addEventListener('click', () => {
        currentIndex = (currentIndex + 1) % cards.length;
        updateCards();
      });
    });

    carousel.querySelectorAll('[data-smartdna-hero-prev]').forEach((button) => {
      button.addEventListener('click', () => {
        currentIndex = (currentIndex - 1 + cards.length) % cards.length;
        updateCards();
      });
    });

    updateCards();
  });

  const quickViewLabels = new Set(['snabbvy', 'quick view']);
  const quickViewReplacement = 'Lägg i kundkorg';
  const observedDocuments = new WeakSet();

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const ensureQuickViewOverrideStyles = (doc) => {
    if (!doc?.head || doc.getElementById('smartdna-wg-quickview-override-style')) return;

    const style = doc.createElement('style');
    style.id = 'smartdna-wg-quickview-override-style';
    style.textContent = `
      .smartdna-wg-quickview-override {
        position: relative !important;
        overflow: hidden !important;
      }

      .smartdna-wg-quickview-override > * {
        opacity: 0 !important;
      }

      .smartdna-wg-quickview-override::after {
        content: attr(data-smartdna-wg-label);
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: inherit;
        background: inherit;
        color: inherit;
        font: inherit;
        font-weight: inherit;
        letter-spacing: inherit;
        line-height: inherit;
        white-space: nowrap;
        text-transform: inherit;
      }
    `;

    doc.head.appendChild(style);
  };

  const markQuickViewElement = (element) => {
    element.classList.add('smartdna-wg-quickview-override');
    element.setAttribute('data-smartdna-wg-label', quickViewReplacement);
  };

  const replaceQuickViewTextNodes = (doc, element) => {
    if (!element) return;

    const matchingTextNodes = [];
    const walker = doc.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          return quickViewLabels.has(normalizeText(node.nodeValue))
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_SKIP;
        },
      }
    );

    while (walker.nextNode()) {
      matchingTextNodes.push(walker.currentNode);
    }

    if (matchingTextNodes.length) {
      markQuickViewElement(element);
      matchingTextNodes.forEach((node) => {
        node.nodeValue = quickViewReplacement;
      });
      return;
    }

    if (quickViewLabels.has(normalizeText(element.textContent))) {
      markQuickViewElement(element);
      element.textContent = quickViewReplacement;
    }
  };

  const updateQuickViewLabels = (doc) => {
    if (!doc?.querySelectorAll) return;
    ensureQuickViewOverrideStyles(doc);

    doc.querySelectorAll('button, a, [role="button"], [aria-label], [title]').forEach((element) => {
      replaceQuickViewTextNodes(doc, element);

      const ariaLabel = element.getAttribute('aria-label');
      if (quickViewLabels.has(normalizeText(ariaLabel))) {
        markQuickViewElement(element);
        element.setAttribute('aria-label', quickViewReplacement);
      }

      const title = element.getAttribute('title');
      if (quickViewLabels.has(normalizeText(title))) {
        markQuickViewElement(element);
        element.setAttribute('title', quickViewReplacement);
      }
    });
  };

  const bindQuickViewOverride = (doc) => {
    if (!doc?.documentElement || observedDocuments.has(doc)) return;
    observedDocuments.add(doc);

    let scheduled = false;
    const scheduleUpdate = () => {
      if (scheduled) return;
      scheduled = true;
      (doc.defaultView || window).requestAnimationFrame(() => {
        scheduled = false;
        updateQuickViewLabels(doc);

        doc.querySelectorAll('iframe').forEach((frame) => {
          try {
            if (frame.contentDocument) bindQuickViewOverride(frame.contentDocument);
          } catch (error) {
            // Ignore cross-origin iframes we cannot inspect.
          }
        });
      });
    };

    const root = doc.body || doc.documentElement;
    if (root) {
      new MutationObserver(scheduleUpdate).observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['aria-label', 'title'],
      });
    }

    doc.querySelectorAll('iframe').forEach((frame) => {
      frame.addEventListener('load', () => {
        try {
          if (frame.contentDocument) bindQuickViewOverride(frame.contentDocument);
        } catch (error) {
          // Ignore cross-origin iframes we cannot inspect.
        }
      });
    });

    scheduleUpdate();
  };

  bindQuickViewOverride(document);

  const wholesaleAccountPagePattern = /\/pages\/ws-account-(login|create)\/?$/;
  const wholesaleTextReplacements = new Map([
    ['wholesale login', 'Återförsäljarinloggning'],
    ['apply for a wholesale account', 'Ansök om företagskonto'],
    ['wholesale registration form', 'Ansök om företagskonto'],
    ['apply for account', 'Ansök om konto'],
    ['need an account?', 'Saknar du konto?'],
    ['sign up here.', 'Ansök om konto här.'],
    ['create a wholesale account', 'Ansök om företagskonto'],
    ['customer information', 'Kunduppgifter'],
    ['shipping address', 'Leveransadress'],
    ['continue', 'Fortsätt'],
    ['already have an account?', 'Har du redan ett konto?'],
    ['login here.', 'Logga in här.'],
    ['email', 'E-post'],
    ['password', 'Lösenord'],
    ['forgot your password?', 'Glömt lösenordet?'],
    ['company', 'Företag'],
    ['company name', 'Företagsnamn'],
    ['required', 'Obligatoriskt'],
    ['missing required fields', 'Obligatoriska fält saknas'],
    ['first name', 'Förnamn'],
    ['last name', 'Efternamn'],
    ['phone number', 'Telefonnummer'],
    ['phone', 'Telefon'],
    ['website', 'Webbplats'],
    ['tax id, abn, or vat number', 'Organisationsnummer eller VAT-nummer'],
    ['address 1', 'Adressrad 1'],
    ['address 2', 'Adressrad 2'],
    ['address line 1', 'Adressrad 1'],
    ['address line 2', 'Adressrad 2'],
    ['city', 'Ort'],
    ['country', 'Land'],
    ['state/province', 'Region'],
    ['zip/postal code', 'Postnummer'],
    ['notes', 'Meddelande'],
    ['message', 'Meddelande'],
    ['submit', 'Skicka'],
    ['verfügbarkeit', 'Tillgänglighet'],
    ['availability', 'Tillgänglighet'],
    ['preis', 'Pris'],
    ['price', 'Pris'],
    ['auf lager', 'I lager'],
    ['in stock', 'I lager'],
    ['out of stock', 'Ej i lager'],
  ]);

  const replacementFor = (value) => wholesaleTextReplacements.get(normalizeText(value));
  const replacePreservingWhitespace = (originalValue, replacementValue) => {
    const leadingWhitespace = originalValue.match(/^\s*/)?.[0] || '';
    const trailingWhitespace = originalValue.match(/\s*$/)?.[0] || '';
    return `${leadingWhitespace}${replacementValue}${trailingWhitespace}`;
  };

  const translateWholesaleTextNodes = (root) => {
    if (!root) return;

    const textNodes = [];
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const replacementValue = replacementFor(node.nodeValue);
          return replacementValue ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        },
      }
    );

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((node) => {
      const replacementValue = replacementFor(node.nodeValue);
      if (replacementValue) node.nodeValue = replacePreservingWhitespace(node.nodeValue, replacementValue);
    });
  };

  const translateWholesaleAttributes = (root) => {
    if (!root?.querySelectorAll) return;

    root.querySelectorAll('[placeholder], [aria-label], [title], input[type="submit"], input[type="button"]').forEach((element) => {
      ['placeholder', 'aria-label', 'title'].forEach((attributeName) => {
        const attributeValue = element.getAttribute(attributeName);
        const replacementValue = replacementFor(attributeValue);
        if (replacementValue) element.setAttribute(attributeName, replacementValue);
      });

      if (element.matches('input[type="submit"], input[type="button"]')) {
        const replacementValue = replacementFor(element.value);
        if (replacementValue) element.value = replacementValue;
      }
    });
  };

  const translateWholesalePortalCopy = (root = document.body) => {
    translateWholesaleTextNodes(root);
    translateWholesaleAttributes(root);
  };

  if (wholesaleAccountPagePattern.test(window.location.pathname)) {
    translateWholesalePortalCopy();

    let wholesaleTranslationScheduled = false;
    new MutationObserver(() => {
      if (wholesaleTranslationScheduled) return;
      wholesaleTranslationScheduled = true;
      window.requestAnimationFrame(() => {
        wholesaleTranslationScheduled = false;
        translateWholesalePortalCopy();
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['placeholder', 'aria-label', 'title', 'value'],
    });
  }
});
